/**
 * Created by Pawel Grzyb 01.04.2018
 *
 * The offer page contains information about company offer.
 */

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-oferta-page',
  templateUrl: './offer-page.component.html',
  styleUrls: [ './offer-page.component.css' ]
})
export class OfferPageComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
